import React, {useEffect} from 'react';
import './Login.scss';
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import {useAuth0} from "../../utils/providers/Auth0Provider";
import logo from "../../assets/Fidelius_Finalized_Logo_Parts-02.svg"
import {navigate} from "@reach/router";


function Login(props) {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/vaults");
    }
  }, [isAuthenticated]);

  props.toggleLoading(false);
  return (
    <div className="flex justify-center login">
      <Card className="login-card flex flex-col text-center">
        <img className="h-40 sm:h-48 mx-auto my-6" src={logo}/>
        <b className="text-2xl sm:text-4xl">Welcome to Fidelius.</b>
        <p className="text-sm sm:text-base mt-0 sm:mt-2">Login or sign up to access your vaults.</p>
        <div className="mt-6 sm:mt-8">
          <Button
            variant="contained"
            color="primary"
            className="text-white login-button"
            onClick={()=>loginWithRedirect()}
          > Login
          </Button>
        </div>
        <hr className="light-grey w-3/4 sm:w-1/2 mx-auto my-5"/>
        <p className="text-sm sm:text-base text-grey">Don't have an account?</p>
        <div className="mt-2 mb-5">
          <Button
            variant="outlined"
            color="secondary"
            className="text-secondary login-button"
            onClick={()=>loginWithRedirect({screen_hint: 'signup'})}
          > Signup
          </Button>
        </div>
        <p className="text-sm text-grey">By signing up for Fidelius, you agree to abide by our <a target={"_blank"} href={"https://www.fideliusvaults.com/terms-of-service"}>Terms of Service</a> and <a target={"_blank"} href={"https://www.fideliusvaults.com/privacy-policy"}>Privacy Policy</a>.</p>
      </Card>
    </div>
  );
};

export default compose(
  connect(
    null,
    { toggleLoading }
  )
)(Login);
